module.exports = __webpack_public_path__ + "img/top01.e6221cb7.gif";